module.exports = __webpack_public_path__ + "img/1210 GR.b823e905.png";